// extracted by mini-css-extract-plugin
export default {"Circle6":"Circle6_Circle6__yD-uj"};